import { InjectionToken } from '@angular/core';

export const LSOS_BASE_PATH = new InjectionToken<string>(
  'Base path for lockton micro-site'
);
